import {
    sendPostRequest,
    sendDeleteRequest,
    sendGetRequest,
    sendPutRequest,
    sendPatchRequest
} from "@/helper/requests";
import {executeRequest} from "@/store/utils";
import representative from "@/urls/roles/representative";

const state = {
    replacements: {
        currentUrl: null,
        items: [],
        loading: false,
        count: 0,
        detail: [],
        // next: null,
        // prev: null,
        error: null
    }
}

const getters = {
    getReplacements: state => state.replacements.items,
    getReplacementsCount: state => state.replacements.count,
    getReplacementsCurrentUrl: state => state.replacements.currentUrl,
    getReplacementsDetail: state => state.replacements.detail,
    // getNext: state => state.replacements.next,
    // getPrev: state => state.replacements.prev,
    isLoadingReplacements: state => state.replacements.loading,
    saveReplacementsError: state => state.replacements.error
}

const actions = {
    loadReplacementsList: ({commit, getters}, {url, urlAppend, finalizer=()=>{}, catcher=()=>{}}) => {
        if (!url) {
            url = representative.REPRESENTATIVE.REPLACEMENTS.LIST()
            if (urlAppend) url = urlAppend(url)
        }
        if (!getters.isLoadingReplacements) {
            commit("SET_REPLACEMENTS_LOADING");
            sendGetRequest(
                url, (data, url) => {
                    commit("SET_REPLACEMENTS", data["results"]);
                    commit("SET_REPLACEMENTS_COUNT", data["count"]);
                    // commit('SET_REPLACEMENTS_NEXT', data['next']);
                    // commit('SET_REPLACEMENTS_PREV', data['prev']);
                    commit("SET_REPLACEMENTS_CURRENT_URL", url);
                    commit("SET_REPLACEMENTS_LOADING_END");
                    finalizer(data, url);
                }, (data, url) => {
                    commit("SET_REPLACEMENTS_LOADING_END");
                    commit("SAVE_REPLACEMENTS_ERROR", data);
                    catcher(data, url);
                }
            )
        }
    },
    loadReplacementsDetail: ({commit}, {url, id, finalizer=()=>{}, catcher=()=>{}}) => {
        if (!url) url = representative.REPRESENTATIVE.REPLACEMENTS.DETAIL(id)
        sendGetRequest(
            url, (data, url) => {
                commit("SET_REPLACEMENTS_DETAIL", data);
                finalizer(data, url);
            }, (data, url) => {
                commit("SAVE_REPLACEMENTS_ERROR", data);
                catcher(data, url);
            }
        )
    },
    createReplacements: ({dispatch, commit, getters}, {data, finalizer=()=>{}, catcher=()=>{}}) => {
        let url = representative.REPRESENTATIVE.REPLACEMENTS.CREATE()
        executeRequest("Replacements", sendPostRequest, {url, data, finalizer, catcher}, {dispatch, commit, getters});
    },
    changeReplacements: ({dispatch, commit, getters}, {id, data, finalizer,catcher}) => {
        let url = representative.REPRESENTATIVE.REPLACEMENTS.UPDATE(id)
        executeRequest("Replacements", sendPutRequest, {url, data, finalizer, catcher}, {dispatch, commit, getters});
    },
    deleteReplacements: ({dispatch, commit, getters}, {id, finalizer, catcher}) => {
        let url = representative.REPRESENTATIVE.REPLACEMENTS.DELETE(id)
        executeRequest("Replacements", sendDeleteRequest, {url, finalizer, catcher}, {dispatch, commit, getters});
    }
}

const mutations = {
    SET_REPLACEMENTS: (state, replacements) => {
        state.replacements.items = replacements
    },
    SET_REPLACEMENTS_DETAIL: (state, value) => {
        state.replacements.detail = value
    },
    SET_REPLACEMENTS_COUNT: (state, value) => {
        state.replacements.count = value
    },
    // SET_NEXT: (state, value) => {
    //   state.replacements.next = value
    // },
    // SET_PREV: (state, value) => {
    //   state.replacements.prev = value
    // },
    SET_REPLACEMENTS_CURRENT_URL: (state, value) => {
        state.replacements.currentUrl = value
    },
    SET_REPLACEMENTS_LOADING: (state) => {
        state.replacements.loading = true
    },
    SET_REPLACEMENTS_LOADING_END: (state) => {
        state.replacements.loading = false
    },
    SAVE_REPLACEMENTS_ERROR: (state, error) => {
        state.replacements.error = error
    }
}

export default {
    namespaced: false,
    state,
    mutations,
    actions,
    getters
}
